// extracted by mini-css-extract-plugin
module.exports = {"shareWrapper":"PostShare_shareWrapper__JOoP7","title":"PostShare_title__GSYqi","button":"PostShare_button__IJaY2"};